import React from 'react'

export const SubscriptionContext = React.createContext({
    expiresAt: 0,
    subscriptionId: null,
    active: false
})